export const getCurrentMonthValue = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

export const monthValueToParts = (monthValue) => {
  const [year, month] = monthValue.split('-');
  return {
    year: Number.parseInt(year, 10),
    month: Number.parseInt(month, 10)
  };
};

export const monthLabel = (year, month) => {
  const date = new Date(Date.UTC(year, month - 1, 1));
  return date.toLocaleString(undefined, { month: 'long', year: 'numeric', timeZone: 'UTC' });
};

export const mapCountsToRows = (counts = {}) => Object.entries(counts)
  .map(([label, count]) => ({ label, count }))
  .sort((a, b) => b.count - a.count);
